const API = process.env.REACT_APP_API_URL || 'https://api.visinvoke.com';
const BASE = '/v1/scc/client-intake';
export async function intakeRequest(path, data, { publicSession = false, signal } = {}) {
  const response = await fetch(API + BASE + path, {
    method: data === undefined ? 'GET' : 'POST',
    credentials: publicSession ? 'omit' : 'include',
    cache: 'no-store', referrerPolicy: 'no-referrer', signal,
    headers: data === undefined ? {} : { 'Content-Type': 'application/json' },
    body: data === undefined ? undefined : JSON.stringify(data),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.error || 'Intake is temporarily unavailable. Please try again.');
    error.status = response.status;
    throw error;
  }
  return body;
}
